<template>
  <footer class="app-footer">
    <div class="app-footer-inner">
      <div class="app-footer-left">
        &copy; {{ currentYear }} Suite241 Gestion Commerciale &middot; Powered by
        <a href="https://suite241.com" target="_blank" rel="noopener noreferrer">
          Suite241
        </a>
      </div>
      <div v-if="$slots.center" class="app-footer-center">
        <slot name="center"></slot>
      </div>
      <div class="app-footer-version">
        Version <strong>{{ appVersion }}</strong>
      </div>
    </div>
  </footer>
</template>

<script>
import pkg from '../../package.json';

export default {
  name: 'AppFooter',
  data() {
    return {
      appVersion: pkg.version || '1.0.0',
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.app-footer {
  background-color: #ffffff;
  border-top: 1px solid #dee2e6;
  color: #6c757d;
  font-size: 0.82rem;
}

.app-footer-inner {
  align-items: center;
  display: grid;
  gap: 0.75rem;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  margin: 0 auto;
  max-width: 1320px;
  padding: 0.65rem 1rem;
  width: 100%;
}

.app-footer-left {
  grid-column: 1;
  min-width: 0;
}

.app-footer-center {
  display: flex;
  grid-column: 2;
  justify-content: center;
}

.app-footer a {
  color: #0b508c;
  font-weight: 700;
  text-decoration: none;
}

.app-footer a:hover {
  text-decoration: underline;
}

.app-footer-version {
  grid-column: 3;
  justify-self: end;
  white-space: nowrap;
}

@media (max-width: 576px) {
  .app-footer-inner {
    align-items: flex-start;
    gap: 0.2rem;
    grid-template-columns: 1fr;
  }

  .app-footer-left,
  .app-footer-center,
  .app-footer-version {
    grid-column: 1;
    justify-self: center;
    text-align: center;
  }
}
</style>
